// extracted by mini-css-extract-plugin
export default {"practiceResult":"PracticeResults_practiceResult__zJVEw"};